// Mock data for Atlas Academy

export const CATEGORIES = [
  'All Courses',
  'Health & Social Care',
  'Business & Management',
  'Education & Training',
  'IT & Technology',
  'Occupational Health & Safety',
  'Law',
  'Early Years & Childcare',
];

export const LEVELS = ['Level 2', 'Level 3', 'Level 4', 'Level 5', 'Level 6', 'Level 7'];
export const AWARDING_BODIES = ['OTHM', 'QUALIFI'];

export const COURSES = [
  // ─── Health & Social Care ────────────────────────────────────────────────
  {
    id: '1', slug: 'level-2-diploma-in-care-acclaim',
    title: 'Level 2 Diploma in Care (OTHM)',
    category: 'Health & Social Care', level: 'Level 2', duration: '6-9 months',
    price: 150, originalPrice: 700, onSale: true,
    description: 'Build a solid foundation in health and care practice. Covers the essential skills and knowledge for anyone starting out or working in a care setting.',
    modules: ['Principles of care', 'Safeguarding and duty of care', 'Communication in care', 'Personal development', 'Equality and diversity'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=650&h=345&fit=crop&q=80',
    featured: true, enrollCount: 324, rating: 4.8, reviewCount: 127,
    paymentPlans: ['Full payment: \u00a3150', 'Deposit: \u00a350 + 2 x \u00a350'], active: true,
  },
  {
    id: '2', slug: 'level-2-adult-social-care-certificate-acclaim',
    title: 'Level 2 Adult Social Care Certificate (OTHM)',
    category: 'Health & Social Care', level: 'Level 2', duration: '3-6 months',
    price: 150, originalPrice: 750, onSale: true,
    description: 'An introductory qualification for those new to adult social care. Gain the confidence and knowledge to support individuals in their daily lives.',
    modules: ['Introduction to adult care', 'Supporting wellbeing', 'Person-centred approaches', 'Health and safety basics'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=650&h=345&fit=crop&q=80',
    featured: true, enrollCount: 245, rating: 4.7, reviewCount: 98,
    paymentPlans: ['Full payment: \u00a3150', 'Deposit: \u00a340 + 2 x \u00a340'], active: true,
  },
  {
    id: '3', slug: 'level-3-diploma-health-social-care-acclaim',
    title: 'Level 3 Diploma in Health and Social Care (OTHM)',
    category: 'Health & Social Care', level: 'Level 3', duration: '9-12 months',
    price: 200, originalPrice: 670, onSale: true,
    description: 'Advance your career in health and social care. Designed for practitioners looking to take on greater responsibilities and improve quality of care.',
    modules: ['Safeguarding in health and care', 'Promoting equality and inclusion', 'Effective communication', 'Mental health awareness', 'Managing care plans'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1586773860418-d37222d8fce3?w=650&h=345&fit=crop&q=80',
    featured: true, enrollCount: 412, rating: 4.9, reviewCount: 187,
    paymentPlans: ['Full payment: \u00a3200', 'Deposit: \u00a360 + 3 x \u00a347'], active: true,
  },
  {
    id: '4', slug: 'level-3-foundation-diploma-health-social-care-certify',
    title: 'Level 3 Foundation Diploma in Health and Social Care (QUALIFI)',
    category: 'Health & Social Care', level: 'Level 3', duration: '6-9 months',
    price: 200, originalPrice: 770, onSale: true,
    description: 'A foundational Level 3 qualification for care practitioners, covering core principles in health, wellbeing, and ethical care delivery.',
    modules: ['Care values and ethics', 'Health and wellbeing', 'Communication in care settings', 'Supporting daily living'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1551190822-a9333d879b1f?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 198, rating: 4.7, reviewCount: 79,
    paymentPlans: ['Full payment: \u00a3200', 'Deposit: \u00a360 + 3 x \u00a347'], active: true,
  },
  {
    id: '5', slug: 'level-3-diploma-adult-health-social-care-certify',
    title: 'Level 3 Diploma in Adult Health and Social Care (QUALIFI)',
    category: 'Health & Social Care', level: 'Level 3', duration: '9-12 months',
    price: 200, originalPrice: 850, onSale: true,
    description: 'A comprehensive qualification covering the core competencies needed to work effectively with adults in health and social care environments.',
    modules: ['Duty of care', 'Person-centred values', 'Promoting wellbeing', 'Safeguarding adults', 'Health and safety practice'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 223, rating: 4.8, reviewCount: 91,
    paymentPlans: ['Full payment: \u00a3200', 'Deposit: \u00a360 + 3 x \u00a347'], active: true,
  },
  {
    id: '6', slug: 'level-4-diploma-health-social-care-acclaim',
    title: 'Level 4 Diploma in Health and Social Care (OTHM)',
    category: 'Health & Social Care', level: 'Level 4', duration: '9-12 months',
    price: 280, originalPrice: 750, onSale: true,
    description: 'Designed for experienced care practitioners ready to take on senior responsibilities. Deepens knowledge of leadership, quality, and complex care needs.',
    modules: ['Leadership in care', 'Complex care needs', 'Quality and safeguarding', 'Professional development', 'Commissioning and service delivery'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 176, rating: 4.8, reviewCount: 68,
    paymentPlans: ['Full payment: \u00a3280', 'Deposit: \u00a380 + 3 x \u00a367'], active: true,
  },
  {
    id: '7', slug: 'level-5-diploma-health-social-care-management-certify',
    title: 'Level 5 Diploma in Health & Social Care Management (QUALIFI)',
    category: 'Health & Social Care', level: 'Level 5', duration: '12-18 months',
    price: 450, originalPrice: 950, onSale: true,
    description: 'A senior management qualification for those leading teams and services in health and care. Covers strategy, governance, and workforce development.',
    modules: ['Strategic leadership', 'Managing resources', 'Quality assurance', 'Workforce development', 'Commissioning services'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1551190822-a9333d879b1f?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 189, rating: 4.8, reviewCount: 74,
    paymentPlans: ['Full payment: \u00a3450', 'Deposit: \u00a3100 + 5 x \u00a370'], active: true,
  },
  {
    id: '8', slug: 'level-6-diploma-health-social-care-certify',
    title: 'Level 6 Diploma in Health & Social Care (QUALIFI)',
    category: 'Health & Social Care', level: 'Level 6', duration: '18-24 months',
    price: 650, originalPrice: 1100, onSale: true,
    description: 'A degree-equivalent qualification for senior professionals. Develops advanced competencies in service leadership, research, and strategic care management.',
    modules: ['Advanced health and care policy', 'Research methods in care', 'Managing organisational change', 'Ethics in care leadership', 'Service improvement'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1586773860418-d37222d8fce3?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 112, rating: 4.7, reviewCount: 44,
    paymentPlans: ['Full payment: \u00a3650', 'Deposit: \u00a3150 + 5 x \u00a3100'], active: true,
  },
  {
    id: '9', slug: 'level-7-diploma-health-social-care-management-certify',
    title: 'Level 7 Diploma in Health & Social Care Management (QUALIFI)',
    category: 'Health & Social Care', level: 'Level 7', duration: '18-24 months',
    price: 800, originalPrice: 1400, onSale: true,
    description: 'Masters-level study in health and social care leadership. Ideal for directors, inspectors, and policy-level professionals seeking postgraduate recognition.',
    modules: ['Strategic health policy', 'Executive leadership', 'Research and analysis', 'Transformational change', 'Regulatory frameworks'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1551190822-a9333d879b1f?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 78, rating: 4.9, reviewCount: 31,
    paymentPlans: ['Full payment: \u00a3800', 'Deposit: \u00a3200 + 6 x \u00a3100'], active: true,
  },
  // ─── Business & Management ───────────────────────────────────────────────
  {
    id: '10', slug: 'level-3-diploma-business-management-acclaim',
    title: 'Level 3 Diploma in Business Management (OTHM)',
    category: 'Business & Management', level: 'Level 3', duration: '6-9 months',
    price: 150, originalPrice: 600, onSale: true,
    description: 'Gain the business knowledge and management skills needed to excel in a commercial environment. Ideal for those entering or progressing in business roles.',
    modules: ['Business operations', 'Marketing principles', 'Financial management', 'Human resources', 'Business communication'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=650&h=345&fit=crop&q=80',
    featured: true, enrollCount: 356, rating: 4.7, reviewCount: 143,
    paymentPlans: ['Full payment: \u00a3150', 'Deposit: \u00a350 + 2 x \u00a350'], active: true,
  },
  {
    id: '11', slug: 'level-3-diploma-business-management-certify',
    title: 'Level 3 Diploma in Business Management (QUALIFI)',
    category: 'Business & Management', level: 'Level 3', duration: '6-9 months',
    price: 150, originalPrice: 750, onSale: true,
    description: 'A career-focused Level 3 Business Management qualification covering core disciplines needed to thrive in modern commercial organisations.',
    modules: ['Business planning', 'Team management', 'Customer relations', 'Sales and marketing', 'Business law fundamentals'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 289, rating: 4.6, reviewCount: 115,
    paymentPlans: ['Full payment: \u00a3150', 'Deposit: \u00a350 + 2 x \u00a350'], active: true,
  },
  {
    id: '12', slug: 'level-3-integrated-diploma-business-management-acclaim',
    title: 'Level 3 Integrated Diploma in Business and Management (OTHM)',
    category: 'Business & Management', level: 'Level 3', duration: '6-9 months',
    price: 180, originalPrice: 800, onSale: true,
    description: 'A broader business qualification combining entrepreneurship, management, and operational skills. Perfect for those looking to run or grow a business.',
    modules: ['Entrepreneurship and innovation', 'Business strategy', 'Operations management', 'Financial literacy', 'Leadership essentials'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 234, rating: 4.6, reviewCount: 92,
    paymentPlans: ['Full payment: \u00a3180', 'Deposit: \u00a360 + 2 x \u00a360'], active: true,
  },
  {
    id: '13', slug: 'level-4-diploma-business-management-acclaim',
    title: 'Level 4 Diploma in Business Management (OTHM)',
    category: 'Business & Management', level: 'Level 4', duration: '9-12 months',
    price: 280, originalPrice: 750, onSale: true,
    description: 'Bridge the gap between team leader and middle management. Builds on business knowledge with a focus on operational strategy and people management.',
    modules: ['Organisational behaviour', 'Business strategy', 'Operations and supply chain', 'Managing people', 'Business finance'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 221, rating: 4.7, reviewCount: 88,
    paymentPlans: ['Full payment: \u00a3280', 'Deposit: \u00a380 + 3 x \u00a367'], active: true,
  },
  {
    id: '14', slug: 'level-5-diploma-business-management-certify',
    title: 'Level 5 Diploma in Business Management (QUALIFI)',
    category: 'Business & Management', level: 'Level 5', duration: '12-18 months',
    price: 380, originalPrice: 900, onSale: true,
    description: 'A higher-level qualification for aspiring business leaders. Develop strategic thinking, analytical skills, and management expertise.',
    modules: ['Strategic business management', 'Leadership and change', 'Operations management', 'Financial strategy', 'Project management'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 201, rating: 4.8, reviewCount: 89,
    paymentPlans: ['Full payment: \u00a3380', 'Deposit: \u00a380 + 5 x \u00a360'], active: true,
  },
  {
    id: '15', slug: 'level-6-diploma-business-management-certify',
    title: 'Level 6 Diploma in Business Management (QUALIFI)',
    category: 'Business & Management', level: 'Level 6', duration: '18-24 months',
    price: 580, originalPrice: 1100, onSale: true,
    description: 'A degree-equivalent business qualification. Provides rigorous coverage of business theory, global management, and executive decision-making.',
    modules: ['Global business strategy', 'Corporate governance', 'Advanced finance', 'International marketing', 'Executive leadership'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 134, rating: 4.7, reviewCount: 52,
    paymentPlans: ['Full payment: \u00a3580', 'Deposit: \u00a3120 + 5 x \u00a392'], active: true,
  },
  {
    id: '16', slug: 'level-7-diploma-strategic-management-acclaim',
    title: 'Level 7 Diploma in Strategic Management (OTHM)',
    category: 'Business & Management', level: 'Level 7', duration: '18-24 months',
    price: 750, originalPrice: 1400, onSale: true,
    description: 'Masters-level strategic management qualification. For senior managers and executives seeking postgraduate-equivalent credentials.',
    modules: ['Corporate strategy', 'Strategic finance', 'Leadership and change management', 'Business research methods', 'Global governance'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 89, rating: 4.9, reviewCount: 35,
    paymentPlans: ['Full payment: \u00a3750', 'Deposit: \u00a3200 + 5 x \u00a3110'], active: true,
  },
  // ─── Education & Training ────────────────────────────────────────────────
  {
    id: '17', slug: 'level-3-award-education-training-acclaim',
    title: 'Level 3 Award in Education and Training (OTHM)',
    category: 'Education & Training', level: 'Level 3', duration: '3-6 months',
    price: 150, originalPrice: 550, onSale: true,
    description: 'The essential qualification for those who want to teach or train others across classroom, workplace, or community settings.',
    modules: ['Understanding the teaching role', 'Planning for learning', 'Facilitating learning', 'Assessing learners'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=650&h=345&fit=crop&q=80',
    featured: true, enrollCount: 278, rating: 4.9, reviewCount: 112,
    paymentPlans: ['Full payment: \u00a3150', 'Deposit: \u00a350 + 2 x \u00a350'], active: true,
  },
  {
    id: '18', slug: 'level-3-award-assessing-vocationally-related-achievement-certify',
    title: 'Level 3 Award in Assessing Vocationally Related Achievement (QUALIFI)',
    category: 'Education & Training', level: 'Level 3', duration: '3-6 months',
    price: 200, originalPrice: 450, onSale: true,
    description: 'For those who assess learners in vocational or work-based settings using portfolio evidence and observation methods.',
    modules: ['Principles of assessment', 'Assessing by portfolio and observation', 'Planning assessments', 'Quality in assessment'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 198, rating: 4.7, reviewCount: 77,
    paymentPlans: ['Full payment: \u00a3200', 'Deposit: \u00a360 + 2 x \u00a360'], active: true,
  },
  {
    id: '19', slug: 'level-4-certificate-education-training-acclaim',
    title: 'Level 4 Certificate in Education and Training (OTHM)',
    category: 'Education & Training', level: 'Level 4', duration: '6-9 months',
    price: 280, originalPrice: 700, onSale: true,
    description: 'A comprehensive Level 4 teaching qualification for practitioners in further education, community learning, or vocational training settings.',
    modules: ['Theories of education', 'Curriculum planning', 'Inclusive teaching methods', 'Assessment practice', 'Reflective teaching'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 167, rating: 4.7, reviewCount: 65,
    paymentPlans: ['Full payment: \u00a3280', 'Deposit: \u00a380 + 3 x \u00a367'], active: true,
  },
  {
    id: '20', slug: 'level-5-diploma-education-training-certify',
    title: 'Level 5 Diploma in Education and Training (QUALIFI)',
    category: 'Education & Training', level: 'Level 5', duration: '12-18 months',
    price: 420, originalPrice: 950, onSale: true,
    description: 'A professional teaching qualification designed for those delivering education in further education, skills training, or vocational settings.',
    modules: ['Teaching in the lifelong learning sector', 'Curriculum design', 'Assessment and quality', 'Professional practice', 'Research in education'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 145, rating: 4.7, reviewCount: 55,
    paymentPlans: ['Full payment: \u00a3420', 'Deposit: \u00a3100 + 4 x \u00a380'], active: true,
  },
  // ─── IT & Technology ─────────────────────────────────────────────────────
  {
    id: '21', slug: 'level-3-diploma-cyber-security-acclaim',
    title: 'Level 3 Diploma in Cyber Security Management and Operations (OTHM)',
    category: 'IT & Technology', level: 'Level 3', duration: '6-9 months',
    price: 250, originalPrice: 800, onSale: true,
    description: 'Develop the skills to protect digital systems, networks, and data. An essential qualification for anyone pursuing a career in cyber security.',
    modules: ['Network security fundamentals', 'Ethical hacking principles', 'Risk management', 'Data protection and GDPR', 'Incident response'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=650&h=345&fit=crop&q=80',
    featured: true, enrollCount: 233, rating: 4.8, reviewCount: 91,
    paymentPlans: ['Full payment: \u00a3250', 'Deposit: \u00a370 + 3 x \u00a360'], active: true,
  },
  {
    id: '22', slug: 'level-3-certificate-python-certify',
    title: 'Level 3 Certificate in Python (QUALIFI)',
    category: 'IT & Technology', level: 'Level 3', duration: '3-6 months',
    price: 200, originalPrice: 650, onSale: true,
    description: 'Learn one of the world\'s most in-demand programming languages from first principles to building real-world applications.',
    modules: ['Python fundamentals', 'Data structures and control flow', 'Functions and modules', 'Working with APIs', 'Project: Build your own application'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 298, rating: 4.9, reviewCount: 134,
    paymentPlans: ['Full payment: \u00a3200', 'Deposit: \u00a360 + 2 x \u00a370'], active: true,
  },
  {
    id: '23', slug: 'level-4-diploma-it-management-acclaim',
    title: 'Level 4 Diploma in IT Management (OTHM)',
    category: 'IT & Technology', level: 'Level 4', duration: '9-12 months',
    price: 320, originalPrice: 850, onSale: true,
    description: 'Develop the technical and managerial skills to lead IT teams and projects. Covers both technical fundamentals and strategic IT management.',
    modules: ['IT systems architecture', 'Project management', 'IT governance and compliance', 'Cloud computing', 'Leading IT teams'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 178, rating: 4.7, reviewCount: 69,
    paymentPlans: ['Full payment: \u00a3320', 'Deposit: \u00a380 + 4 x \u00a360'], active: true,
  },
  {
    id: '24', slug: 'level-5-diploma-cyber-security-certify',
    title: 'Level 5 Diploma in Cyber Security Management (QUALIFI)',
    category: 'IT & Technology', level: 'Level 5', duration: '12-18 months',
    price: 480, originalPrice: 950, onSale: true,
    description: 'An advanced cyber security qualification for professionals managing digital risk, security operations, and governance programmes.',
    modules: ['Advanced network security', 'Cyber threat intelligence', 'Security operations centre', 'Digital forensics', 'Security governance and compliance'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 143, rating: 4.8, reviewCount: 56,
    paymentPlans: ['Full payment: \u00a3480', 'Deposit: \u00a3100 + 5 x \u00a376'], active: true,
  },
  {
    id: '25', slug: 'level-7-diploma-strategic-it-management-certify',
    title: 'Level 7 Diploma in Strategic IT Management (QUALIFI)',
    category: 'IT & Technology', level: 'Level 7', duration: '18-24 months',
    price: 780, originalPrice: 1400, onSale: true,
    description: 'A masters-level qualification for senior IT directors and CIOs covering strategic technology planning, digital transformation, and AI governance.',
    modules: ['Digital transformation strategy', 'AI and emerging technologies', 'IT governance frameworks', 'Cybersecurity strategy', 'Technology leadership'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 67, rating: 4.9, reviewCount: 26,
    paymentPlans: ['Full payment: \u00a3780', 'Deposit: \u00a3200 + 5 x \u00a3116'], active: true,
  },
  // ─── Occupational Health & Safety ────────────────────────────────────────
  {
    id: '26', slug: 'level-3-technical-cert-ohs-certify',
    title: 'Level 3 Technical Certificate in Occupational Health & Safety (QUALIFI)',
    category: 'Occupational Health & Safety', level: 'Level 3', duration: '3-6 months',
    price: 250, originalPrice: 850, onSale: true,
    description: 'Gain the core technical knowledge to identify, assess, and manage workplace health and safety hazards across all industry sectors.',
    modules: ['Health and safety legislation', 'Risk assessment methods', 'Workplace hazard identification', 'Emergency procedures', 'Safety reporting'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1504439468489-c8920d796a29?w=650&h=345&fit=crop&q=80',
    featured: true, enrollCount: 267, rating: 4.8, reviewCount: 104,
    paymentPlans: ['Full payment: \u00a3250', 'Deposit: \u00a370 + 3 x \u00a360'], active: true,
  },
  {
    id: '27', slug: 'level-5-diploma-ohs-management-certify',
    title: 'Level 5 Diploma in Occupational Health & Safety Management (QUALIFI)',
    category: 'Occupational Health & Safety', level: 'Level 5', duration: '12-18 months',
    price: 450, originalPrice: 950, onSale: true,
    description: 'For health and safety professionals seeking to move into senior management or advisory roles. Covers complex risk, policy, and culture change.',
    modules: ['Occupational health strategy', 'Advanced risk management', 'Health and safety culture', 'Legislation and compliance', 'Incident investigation'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1504439468489-c8920d796a29?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 145, rating: 4.7, reviewCount: 57,
    paymentPlans: ['Full payment: \u00a3450', 'Deposit: \u00a3100 + 5 x \u00a370'], active: true,
  },
  {
    id: '28', slug: 'level-6-diploma-ohs-management-certify',
    title: 'Level 6 Diploma in Occupational Health & Safety Management (QUALIFI)',
    category: 'Occupational Health & Safety', level: 'Level 6', duration: '18-24 months',
    price: 620, originalPrice: 1200, onSale: true,
    description: 'A degree-equivalent qualification for health and safety directors and consultants. Covers strategic safety leadership and international frameworks.',
    modules: ['Strategic occupational health', 'International safety standards', 'Corporate governance in safety', 'Research methods', 'Safety management systems'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1504439468489-c8920d796a29?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 89, rating: 4.8, reviewCount: 34,
    paymentPlans: ['Full payment: \u00a3620', 'Deposit: \u00a3150 + 5 x \u00a394'], active: true,
  },
  // ─── Law ─────────────────────────────────────────────────────────────────
  {
    id: '29', slug: 'level-3-diploma-law-certify',
    title: 'Level 3 Diploma in Law (QUALIFI)',
    category: 'Law', level: 'Level 3', duration: '6-9 months',
    price: 200, originalPrice: 800, onSale: true,
    description: 'A thorough grounding in the English legal system for those considering a legal career or wanting to understand how law impacts everyday life.',
    modules: ['The English legal system', 'Contract law basics', 'Criminal law', 'Tort law', 'Employment law fundamentals'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 176, rating: 4.7, reviewCount: 68,
    paymentPlans: ['Full payment: \u00a3200', 'Deposit: \u00a360 + 3 x \u00a347'], active: true,
  },
  {
    id: '30', slug: 'level-3-diploma-law-acclaim',
    title: 'Level 3 Diploma in Law (OTHM)',
    category: 'Law', level: 'Level 3', duration: '6-9 months',
    price: 200, originalPrice: 700, onSale: true,
    description: 'A practical introduction to UK law covering key legal principles across contract, criminal, employment, and consumer law.',
    modules: ['Legal system overview', 'Contract and commercial law', 'Criminal law', 'Civil law and dispute resolution', 'Legal research skills'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1436450412740-6b988f486c6b?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 156, rating: 4.7, reviewCount: 61,
    paymentPlans: ['Full payment: \u00a3200', 'Deposit: \u00a360 + 3 x \u00a347'], active: true,
  },
  {
    id: '31', slug: 'level-4-diploma-law-certify',
    title: 'Level 4 Diploma in Law (QUALIFI)',
    category: 'Law', level: 'Level 4', duration: '9-12 months',
    price: 320, originalPrice: 800, onSale: true,
    description: 'An intermediate law qualification deepening understanding of civil, criminal, and commercial law for practitioners and legal professionals.',
    modules: ['Advanced contract law', 'Property law', 'Company law basics', 'Evidence and procedure', 'International law overview'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 134, rating: 4.6, reviewCount: 52,
    paymentPlans: ['Full payment: \u00a3320', 'Deposit: \u00a380 + 4 x \u00a360'], active: true,
  },
  {
    id: '32', slug: 'level-5-diploma-law-certify',
    title: 'Level 5 Diploma in Law (QUALIFI)',
    category: 'Law', level: 'Level 5', duration: '12-18 months',
    price: 480, originalPrice: 1000, onSale: true,
    description: 'A higher-level law qualification for those pursuing professional legal roles or progressing towards further study in law.',
    modules: ['Advanced contract law', 'Constitutional law', 'Equity and trusts', 'Dispute resolution', 'Jurisprudence'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1436450412740-6b988f486c6b?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 112, rating: 4.6, reviewCount: 43,
    paymentPlans: ['Full payment: \u00a3480', 'Deposit: \u00a3100 + 5 x \u00a376'], active: true,
  },
  {
    id: '33', slug: 'level-7-diploma-law-certify',
    title: 'Level 7 Diploma in Law (QUALIFI)',
    category: 'Law', level: 'Level 7', duration: '18-24 months',
    price: 800, originalPrice: 1500, onSale: true,
    description: 'A masters-level law qualification for senior legal practitioners, corporate counsel, and those pursuing academic or consultancy careers in law.',
    modules: ['Advanced jurisprudence', 'Commercial law and governance', 'International legal systems', 'Legal research methodology', 'Ethics and professional conduct'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 67, rating: 4.7, reviewCount: 26,
    paymentPlans: ['Full payment: \u00a3800', 'Deposit: \u00a3200 + 6 x \u00a3100'], active: true,
  },
  // ─── Early Years & Childcare ─────────────────────────────────────────────
  {
    id: '34', slug: 'level-3-diploma-early-years-education-acclaim',
    title: 'Level 3 Diploma in Early Years Education and Care (OTHM)',
    category: 'Early Years & Childcare', level: 'Level 3', duration: '9-12 months',
    price: 200, originalPrice: 1000, onSale: true,
    description: 'Become a qualified Early Years Educator. The ideal route into nursery, reception, or childminding settings, covering child development and learning.',
    modules: ['Child development (0-5 years)', 'Safe environments for children', 'Play and creativity', 'Communication and language', 'Partnership with families'],
    awardingBody: 'OTHM',
    image: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=650&h=345&fit=crop&q=80',
    featured: true, enrollCount: 389, rating: 4.9, reviewCount: 162,
    paymentPlans: ['Full payment: \u00a3200', 'Deposit: \u00a360 + 3 x \u00a347'], active: true,
  },
  {
    id: '35', slug: 'level-4-diploma-early-childhood-education-certify',
    title: 'Level 4 Diploma in Early Childhood Education (QUALIFI)',
    category: 'Early Years & Childcare', level: 'Level 4', duration: '9-12 months',
    price: 300, originalPrice: 800, onSale: true,
    description: 'A specialist qualification for experienced early years practitioners. Develop expertise in curriculum planning, observation, and professional leadership.',
    modules: ['Theories of child development', 'Inclusive practice', 'EYFS curriculum frameworks', 'Leadership and management', 'Research in early years'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1526634332515-d56c5fd16991?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 156, rating: 4.8, reviewCount: 60,
    paymentPlans: ['Full payment: \u00a3300', 'Deposit: \u00a380 + 4 x \u00a355'], active: true,
  },
  {
    id: '36', slug: 'level-5-diploma-early-childhood-education-certify',
    title: 'Level 5 Diploma in Early Childhood Education (QUALIFI)',
    category: 'Early Years & Childcare', level: 'Level 5', duration: '12-18 months',
    price: 400, originalPrice: 950, onSale: true,
    description: 'An advanced qualification for experienced childcare professionals. Develop leadership skills, deepen understanding of child development, and qualify for senior roles.',
    modules: ['Advanced child development', 'Leadership in early years', 'Policy and curriculum frameworks', 'Safeguarding and welfare', 'Research-based practice'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 143, rating: 4.8, reviewCount: 55,
    paymentPlans: ['Full payment: \u00a3400', 'Deposit: \u00a3100 + 5 x \u00a360'], active: true,
  },
  {
    id: '37', slug: 'level-6-diploma-early-childhood-education-certify',
    title: 'Level 6 Diploma in Early Childhood Education (QUALIFI)',
    category: 'Early Years & Childcare', level: 'Level 6', duration: '18-24 months',
    price: 580, originalPrice: 1100, onSale: true,
    description: 'A degree-equivalent qualification for senior early years professionals and setting managers. Covers policy, research, and strategic leadership.',
    modules: ['Early childhood policy', 'Strategic leadership in early years', 'Research methods', 'Inclusive education', 'Professional practice and ethics'],
    awardingBody: 'QUALIFI',
    image: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=650&h=345&fit=crop&q=80',
    featured: false, enrollCount: 98, rating: 4.7, reviewCount: 38,
    paymentPlans: ['Full payment: \u00a3580', 'Deposit: \u00a3120 + 5 x \u00a392'], active: true,
  },
];

export const FEATURED_COURSES = COURSES.filter(c => c.featured);

export const FAQS = [
  { id: '1', question: 'How does distance learning work?', answer: 'All study materials are delivered through our secure online learning portal. Once enrolled, you will gain immediate access to your course content, including reading materials, assignments, and tutor feedback. You study entirely at your own pace, with no fixed timetable.' },
  { id: '2', question: 'Are the qualifications officially recognised?', answer: 'Yes. All qualifications offered by Atlas Academy are awarded by Ofqual-regulated awarding bodies and appear on the national qualifications framework. They are recognised by employers and further education providers across the UK.' },
  { id: '3', question: 'How long do I have to complete my course?', answer: 'Most courses allow up to 12 months for completion. Shorter programmes typically allow 6 months. If you need additional time, you can speak to your adviser about an extension.' },
  { id: '4', question: 'What tutor support is available?', answer: 'Every student is assigned a dedicated specialist tutor who can be contacted via our online portal, email, or phone. Tutors provide feedback on assignments, answer questions, and offer encouragement throughout your studies.' },
  { id: '5', question: 'Can I enrol if I have no previous qualifications?', answer: 'Many of our Level 2 and Level 3 courses do not require prior qualifications. Entry requirements vary by programme. Our advisers will assess your suitability and recommend the most appropriate starting point.' },
  { id: '6', question: 'What payment options are available?', answer: 'You can pay the full course fee upfront or spread the cost with one of our flexible payment plans. Most courses require only a small deposit to begin, with the remaining balance spread over monthly instalments.' },
  { id: '7', question: 'Do I need any special equipment?', answer: 'All you need is a reliable internet connection and a device such as a laptop, desktop computer, or tablet. No specialist software is required. Our portal is fully accessible from any modern web browser.' },
  { id: '8', question: 'How will I be assessed?', answer: 'Assessment methods vary by qualification but typically include written assignments, case studies, and portfolio work. There are no timed exams for most programmes. All work is submitted digitally through the student portal.' },
  { id: '9', question: 'Can I study while working full-time?', answer: 'Absolutely. Our courses are specifically designed for working adults. There are no set class times and all materials are available 24/7. Most students study for 8-10 hours per week, though this is entirely up to you.' },
  { id: '10', question: 'What happens after I complete my qualification?', answer: 'Upon successful completion, you will receive your official certificate from the awarding body. We also provide a career guidance service and can advise on pathways for further study or progression within your sector.' },
];

// Keep these verifiable — fabricated figures (pass rates, learner counts)
// breach UK advertising standards (ASA/CAP code).
export const STATS = [
  { value: '40+', label: 'Accredited Courses' },
  { value: '2–7', label: 'Qualification Levels' },
  { value: '24/7', label: 'Online Portal Access' },
  { value: '100%', label: 'Online & Flexible Study' },
];

export const PRICING_PLANS = [
  { id: 'starter', name: 'Level 2 Courses', priceFrom: 120, priceTo: 250, description: 'Introductory qualifications for those new to a sector or returning to study.', features: ['Full online course materials', 'Dedicated tutor support', 'Up to 6 months to complete', 'Digital certificate upon completion', 'Flexible payment plan available', 'Student portal access'] },
  { id: 'professional', name: 'Level 3 Courses', priceFrom: 150, priceTo: 450, popular: true, description: 'Career-advancing qualifications for practitioners and aspiring professionals.', features: ['Full online course materials', 'Priority tutor support', 'Up to 12 months to complete', 'Official OFQUAL-regulated certificate', 'Flexible payment plan available', 'Student portal access', 'Career guidance included'] },
  { id: 'advanced', name: 'Level 4–7 Courses', priceFrom: 280, priceTo: 800, description: 'Higher-level qualifications for senior roles, management, and specialist practice.', features: ['Full online course materials', 'Senior tutor support', 'Up to 18 months to complete', 'Official OFQUAL-regulated certificate', 'Flexible payment plan available', 'Student portal access', 'Career and progression guidance', 'Priority enrolment support'] },
];
